import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "item__icon"
};
var _hoisted_2 = {
  key: 1,
  class: "item__icon"
};
var _hoisted_3 = {
  class: "tree__name"
};
import { computed } from 'vue';
import { isNullValue } from '../utils';
export default {
  __name: 'TreeItem',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    level: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    }
  },
  emits: ['onChange'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    /**
     * 是否为指标
     */
    var isTarget = computed(function () {
      return !isNullValue(props.item.targetId);
    });

    /**
     * 是否选中
     */
    var isSelect = computed(function () {
      if (isTarget.value) {
        var item = props.item,
          value = props.value;
        return item.targetId.toString() === value;
      }
      return false;
    });
    /**
     * 选中事件
     */
    var clickSelectedEvent = function clickSelectedEvent(item) {
      if (isNullValue(item.targetId)) {
        item.show = !item.show;
        return;
      }
      emit('onChange', item);
    };
    var onChangeEvent = function onChangeEvent(item) {
      emit('onChange', item);
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_TreeItem = _resolveComponent("TreeItem", true);
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: _normalizeClass(['eva-tree__item', isSelect.value && 'is-select', {
          'is-target': !isTarget.value
        }]),
        style: _normalizeStyle("padding-left: ".concat(16 + __props.level * 24, "px;")),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return clickSelectedEvent(__props.item);
        })
      }, [isTarget.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_svg_icon, {
        name: isSelect.value ? 'flag-active' : 'flag',
        class: "icon",
        size: "16"
      }, null, 8, ["name"])])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_svg_icon, {
        name: "caret-down-small",
        class: _normalizeClass(__props.item.show ? 'arrow_icon' : 'arrow_icon_90deg'),
        size: "18"
      }, null, 8, ["class"])])), _createElementVNode("span", _hoisted_3, _toDisplayString(__props.item.name), 1)], 6), __props.item.show ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(__props.item.children, function (item) {
        return _openBlock(), _createBlock(_component_TreeItem, {
          key: item.id,
          level: __props.level + 1,
          item: item,
          value: __props.value,
          onOnChange: onChangeEvent
        }, null, 8, ["level", "item", "value"]);
      }), 128)) : _createCommentVNode("", true)]);
    };
  }
};